import React, { useEffect, useState } from 'react';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { api } from '../services';
import { validateBirthYear } from '../utils/validateBirthYear';
import { checkCodeMeli } from '../utils/checkCodeMeli';

export const EditPro = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [l1e, setL1] = useState('');
  const [l2e, setL2] = useState('');
  const [l3e, setL3] = useState('');
  const [l4e, setL4] = useState('');
  const [gender, setGender] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isKeyboardPersian, setIsKeyboardPersian] = useState(true);

  // تابع اعتبارسنجی متن فارسی
  const isPersianText = (text) => {
    const persianPattern = /^[\u0600-\u06FF\s]+$/;
    return persianPattern.test(text);
  };

  // تابع تشخیص زبان کیبورد
  const detectKeyboardLanguage = (e) => {
    const key = e.key;
    if (key && key.length === 1) { // فقط کلیدهای حروف را بررسی می‌کنیم
      const isEnglishKey = /[a-zA-Z]/.test(key);
      if (isEnglishKey) {
        setIsKeyboardPersian(false);
        showError('لطفاً زبان کیبورد خود را به فارسی تغییر دهید');
        e.preventDefault(); // از تایپ حروف انگلیسی جلوگیری می‌کند
        return false;
      }
    }
    return true;
  };

  // تابع‌های به‌روزرسانی با اعتبارسنجی فارسی
  const handleNameChange = (e) => {
    const value = e.target.value;
    if (value === '' || isPersianText(value)) {
      setL1(value);
    }
  };

  const handleFamilyChange = (e) => {
    const value = e.target.value;
    if (value === '' || isPersianText(value)) {
      setL2(value);
    }
  };

  const infoSectionStyle = {
    marginBottom: '10px',
    textAlign: 'justify',
  };

  const valueStyle = {
    color: '#666',
  };

  const phoneNumber = localStorage.getItem('phoneNumber');
  const key = localStorage.getItem('key');

  // تبدیل ارقام فارسی/عربی به انگلیسی
  const toEnglishDigits = (input) => {
    if (!input) return '';
    return String(input)
      .replace(/[\u06F0-\u06F9]/g, (d) => String(d.charCodeAt(0) - 1776))
      .replace(/[\u0660-\u0669]/g, (d) => String(d.charCodeAt(0) - 1632));
  };

  // تبدیل ارقام انگلیسی به فارسی برای نمایش
  const toPersianDigits = (input) => {
    if (input === undefined || input === null) return '';
    return String(input).replace(/\d/g, (d) => String.fromCharCode(d.charCodeAt(0) + 1728));
  };

  // هندلر سال تولد: دریافت هر ورودی عددی (فارسی/انگلیسی) و نگهداری انگلیسی
  const handleBirthYearChange = (e) => {
    const normalized = toEnglishDigits(e.target.value).replace(/[^0-9]/g, '').slice(0, 4);
    setL4(normalized);
  };

  // هندلر کد ملی: دریافت هر ورودی عددی (فارسی/انگلیسی) و نگهداری انگلیسی
  const handleNationalCodeChange = (e) => {
    const normalized = toEnglishDigits(e.target.value).replace(/[^0-9]/g, '').slice(0, 10);
    setL3(normalized);
  };

  // بررسی امن کد ملی با نرمال‌سازی ارقام
  const checkCodeMliSafe = (value) => {
    const normalized = toEnglishDigits(value);
    return checkCodeMeli(normalized);
  };

  const submitRegister = async () => {
    if (!l1e) return showError('نام را وارد کنید');
    if (!l2e) return showError('نام خانوادگی را وارد کنید');
    if (!validateBirthYear(l4e)) return showError('سال تولد باید بین 1300 تا 1404 باشد');
    if (!l3e || toEnglishDigits(l3e).length !== 10) return showError('کد ملی باید ده رقم باشد');
    if (!checkCodeMliSafe(l3e)) return showError('فرمت کد ملی صحیح نمی‌باشد');
    if (!gender) return showError('جنسیت را انتخاب کنید');

    try {
      await api.get(
        `Home/CompeleteProfile?SesID=${key}&MobileNumber=${phoneNumber}&Fname=${l1e}&Lname=${l2e}&NationalCode=${toEnglishDigits(l3e)}&BirthDate=${toEnglishDigits(l4e)}&Gender=${gender === 'male' ? 1 : 2}&OID=1`,
      );
      localStorage.setItem('Fname', l1e);
      localStorage.setItem('Lname', l2e);
      localStorage.setItem('Gender', gender);
      navigate('/profile');
    } catch (error) {
      console.log(error);
      showError('خطا در ارتباط با سرور');
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setErrorMessage('');
  };

  const showError = (message) => {
    setErrorMessage(message);
    setShowModal(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(
          `Home/GetProfileInfo?SesID=${key}&OID=1`,
        );
        const data = response.data;
        
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (error) {
            console.error('Invalid JSON string:', data);
            return;
          }
        }
        
        const { Melicode, Gender } = data[0];
        let validCodeMeli = checkCodeMeli(Melicode) ? Melicode : null;

        setL1(data[0].Fname);
        setL2(data[0].Lname);
        setL4(data[0].Birthdate);
        setL3(validCodeMeli);
        setGender(Gender === 1 ? 'male' : Gender === 2 ? 'female' : '');
      } catch (error) {
        console.error('Error fetching doctor list:', error);
      }
    };
    fetchData();
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <style>
        {`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }
          .modal-content {
            background: white;
            padding: 20px;
            border-radius: 8px;
            max-width: 400px;
            width: 100%;
            text-align: center;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          }
          .modal-content h4 {
            margin-bottom: 15px;
            color: #d32f2f;
          }
          .modal-content button {
            background: #007bff;
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 4px;
            cursor: pointer;
          }
          .modal-content button:hover {
            background: #0056b3;
          }
        `}
      </style>
      <section className="container maxw mb-5">
        <div className="row mb-4 mt-2">
          <div className="col-lg-12 path">
            <ul>
              <li>
                <Link className="text-decoration-none" to="/">
                  صفحه اصلی
                </Link>
                <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
              </li>
              {location.state?.from && (
                <li>
                  <span style={{ cursor: 'pointer' }} onClick={handleBack} className="text-primary">
                    {location.state.from}
                  </span>
                  <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
                </li>
              )}
              <li>
                <span>تکمیل پروفایل</span>
              </li>
            </ul>
          </div>
        </div>
        <span hidden>{key}</span>
        <div className="justify-content-center mt-2 p-0">
          <div className="row">
            <div className="col-lg-6">
              <div className="card-body card p-3 shadow rounded-3 p-4 text-center" style={{ height: '100%' }}>
                <h4>ویرایش اطلاعات</h4>
                <div style={infoSectionStyle}>
                  <span style={valueStyle}>
                    <input
                      type="text"
                      maxLength={20}
                      className="form-control"
                      placeholder="شماره موبایل"
                      disabled={true}
                      value={phoneNumber}
                    />
                  </span>
                </div>
                <div style={infoSectionStyle}>
                  <span style={valueStyle}>
                    <input
                      type="text"
                      maxLength={20}
                      className="form-control"
                      placeholder="نام"
                      value={l1e}
                      onChange={handleNameChange}
                      onKeyDown={detectKeyboardLanguage}
                    />
                  </span>
                </div>
                <div style={infoSectionStyle}>
                  <span style={valueStyle}>
                    <input
                      type="text"
                      maxLength={35}
                      className="form-control"
                      placeholder="نام خانوادگی"
                      value={l2e}
                      onChange={handleFamilyChange}
                      onKeyDown={detectKeyboardLanguage}
                    />
                  </span>
                </div>
                <div style={infoSectionStyle}>
                  <span style={valueStyle}>
                    <input
                      type="text"
                      maxLength={4}
                      className="form-control"
                      placeholder="سال تولد (1370)"
                      value={toPersianDigits(l4e)}
                      onInput={handleBirthYearChange}
                    />
                  </span>
                </div>
                <div style={infoSectionStyle}>
                  <span style={valueStyle}>
                    <input
                      type="text"
                      maxLength={10}
                      className="form-control"
                      placeholder="کد ملی (2260360201)"
                      value={toPersianDigits(l3e)}
                      onChange={handleNationalCodeChange}
                    />
                  </span>
                </div>
                <div style={infoSectionStyle}>
                  <span style={valueStyle}>
                    <select
                      className="form-control"
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                    >
                      <option value="">انتخاب کنید</option>
                      <option value="male">مرد</option>
                      <option value="female">زن</option>
                    </select>
                  </span>
                </div>
                <button className="btn btn-primary" onClick={submitRegister} style={{ width: '120px', margin: '0 auto', display: 'block' }}>
                  ویرایش
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card-body card p-3 shadow rounded-3 p-4 text-center" style={{ height: '100%' }}>
                <img
                  src="Img/imguser.jpg"
                  alt="Profile"
                  style={{
                    width: '100%',
                    maxHeight: '340px',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h4>خطا</h4>
            <p>{errorMessage}</p>
            <button className="btn btn-primary" onClick={closeModal}>
              بستن
            </button>
          </div>
        </div>
      )}
    </>
  );
};